import Header from '@packages/shared/core/common/components/layout/Header';
import { TypeOfReadingScreenProps } from '@packages/shared/core/quiz/entities';
import Image from '@packages/shared/core/common/components/common/Image';
import Banner from '@packages/shared/simple-simple-registration/components/Banner';
import ProgressBar from '@packages/shared/simple-simple-registration/components/ProgressBar';
import ButtonBack from '@packages/shared/core/common/components/common/ButtonBack';
import styles from './TypeOfReadingScreen.module.scss';

const TypeOfReadingScreen = ({
  content,
  onChosen,
  index: activeStep,
  totalSteps,
  goBack,
}: TypeOfReadingScreenProps) => {
  return (
    <>
      <div className={styles.background} />

      <Banner />

      <Header className={styles.header} menuClassName={styles.menu}>
        <ButtonBack className={styles.buttonBack} secondary onClick={goBack} />
      </Header>

      <div className={styles.container}>
        <ProgressBar
          className={styles.progressBar}
          title={content.progressTitle}
          steps={totalSteps}
          activeStep={activeStep}
        />

        <h2 className={styles.title}>{content.title}</h2>

        <h3 className={styles.subtitle}>{content.subtitle}</h3>

        <ul className={styles.list}>
          {content.list.map(({ text, icon, value }) => (
            <li role="button" onClick={() => onChosen({ text, value })} key={text} className={styles.listItemWrapper}>
              <div className={styles.listItem}>
                <Image className={styles.icon} type="future" src={icon} alt={text} width={56} height={56} />

                <p className={styles.text}>{text}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default TypeOfReadingScreen;
